import React from 'react';

import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import { Typography } from '@material-ui/core';
import { Variant } from '@material-ui/core/styles/createTypography';

type TypographyLabelUiOptions = {
  variant?: Variant;
};

export const TypographyLabel = (
  props: FieldExtensionComponentProps<string>,
) => {
  const {
    schema: { title = '' },
    uiSchema,
  } = props;

  const variant: Variant =
    (uiSchema?.['ui:options'] as TypographyLabelUiOptions)?.variant ?? 'h6';

  return <Typography variant={variant}>{title}</Typography>;
};
